(() => {
  const setGroupState = (group, expanded) => {
    const control = group.querySelector('[data-ckn-submenu-toggle]');
    const panel = control ? document.getElementById(control.getAttribute('aria-controls')) : null;

    if (!control || !panel) return;

    group.classList.toggle('is-open', expanded);
    control.setAttribute('aria-expanded', String(expanded));
    panel.setAttribute('aria-hidden', String(!expanded));
  };

  document.querySelectorAll('[data-ckn-mobile-nav]').forEach((navigation) => {
    if (navigation.dataset.cknMobileNavReady === 'true') return;

    navigation.dataset.cknMobileNavReady = 'true';
    const toggleFromEvent = (event) => {
      const control = event.target.closest('[data-ckn-submenu-toggle]');
      if (!control || !navigation.contains(control)) return;

      const group = control.closest('[data-ckn-submenu-group]');
      if (!group) return;

      setGroupState(group, control.getAttribute('aria-expanded') !== 'true');
    };

    navigation.addEventListener('click', toggleFromEvent);
    navigation.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      if (!event.target.closest('[data-ckn-submenu-toggle]')) return;

      event.preventDefault();
      toggleFromEvent(event);
    });

    const drawer = navigation.closest('#Details-menu-drawer-container');
    if (!drawer) return;

    drawer.addEventListener('toggle', () => {
      if (drawer.open) return;
      navigation.querySelectorAll('[data-ckn-submenu-group]').forEach((group) => setGroupState(group, false));
    });
  });
})();
